export const useIIFE = (callback) => {
    return iife(callback);
};
const iife = (callback) => callback();
